import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { EventPopupComponent } from 'src/app/events/components/event-popup/event-popup.component';
import { CarouselService } from '../../services/carousel.service';
import { MapAsideService } from 'src/app/panel/components/map-aside/service/map-aside.service';
import { EventSocketService } from 'src/app/events/services/event-socket.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('carouselWrapper') carouselWrapper!: ElementRef;
  @ViewChild('carouselSection') carouselSection!: ElementRef;
  @Input() display = true;

  public isOpenAsideMap = false;

  constructor(
    private carouselService: CarouselService,
    private resolver: ComponentFactoryResolver,
    private containerView: ViewContainerRef,
    private mapAsideService: MapAsideService,
    private cdr: ChangeDetectorRef,
    private eventSocketService: EventSocketService
  ) {
    this.mapAsideService.isHidden$.subscribe((isHidden) => {
      this.isOpenAsideMap = isHidden;
    });
  }

  private subscription!: Subscription;
  scrollDiv!: ElementRef;
  _qtyItems = 0;
  get qtyItems(): number {
    return this._qtyItems;
  }

  set qtyItems(newValue) {
    if (0 <= newValue) {
      this._qtyItems = newValue;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['display']) {
      this.cdr.detectChanges();
    }
  }

  ngOnInit(): void {
    this.eventSocketService.eventPopup.subscribe((data) => {
      this.onNewEvent(data);
    });
  }

  onNewEvent(event: any) {
    console.log('eventssss on event: ', event);
    const auxEvent = {
      id: Date.now().toString(),
      vehicles: [event.tracker],
      event: event.event,
      mapConf: {
        containerId:
          'popup-container-' + event.event.evento_id.toString() + Date.now(),
        maxZoom: 17,
        zoom: 17,
      },
    };
    console.log(auxEvent, 'evento pop carusel');
    this.addEventPopup(auxEvent);
    //this.carouselService.addPopup(auxEvent)
    return;

    this.carouselService.add(EventPopupComponent, { configuration: auxEvent });
  }

  @ViewChild('dynamicComponentsContainer', { read: ViewContainerRef })
  container!: ViewContainerRef;

  private subscriptionsPopups: any[] = [];
  private componentRefs: ComponentRef<EventPopupComponent>[] = [];
  private componentRefsMap: {
    [uuid: string]: ComponentRef<EventPopupComponent>;
  } = {};

  ngAfterViewInit(): void {
    this.updateButtonVisibility();
    this.subscriptionsPopups.push(
      this.carouselService.eventPopups.subscribe((event) => {
        //this.updateComponentPopups(event)
      })
    );
    return;
    this.subscription = this.carouselService.addItem.subscribe(
      ({ component, data }) => {
        const factory = this.resolver.resolveComponentFactory(component);
        const componentRef: ComponentRef<any> =
          this.containerView.createComponent(factory);

        // Agregar el componente directamente al contenedor del carrusel
        const divContainer = document.createElement('div');
        divContainer.style.width = '240px';
        divContainer.id = 'div-' + data['configuration'].mapConf.containerId;
        divContainer.appendChild(componentRef.location.nativeElement);

        const currentWrapperWidth =
          parseFloat(this.carouselWrapper.nativeElement.style.width) || 0;
        const carouselSectionWidth =
          parseFloat(this.carouselSection.nativeElement.style.width) || 0;
        const extraWidth = 240 + 8;

        this.carouselWrapper.nativeElement.style.width = `${
          currentWrapperWidth + extraWidth
        }px`;
        this.carouselSection.nativeElement.style.width = `${
          carouselSectionWidth + extraWidth
        }px`;

        if (data) {
          Object.keys(data).forEach((key) => {
            componentRef.instance[key] = data[key];
          });
        }
        document
          .querySelector('.carousel-wrapper')!
          .insertBefore(
            divContainer,
            document.querySelector('.carousel-wrapper')!.firstChild
          );

        this.qtyItems++;
        this.updateButtonVisibility();

        if (componentRef.instance instanceof EventPopupComponent) {
          componentRef.instance.onDelete.subscribe((valor) => {
            this.deleteMap(valor);
          });
        }

        this.cdr.detectChanges();

        setTimeout(() => {
          this.deleteMap(data['configuration'].mapConf.containerId);

          if (componentRef) {
            componentRef.destroy();
          }

          this.cdr.detectChanges();
        }, 120000);
      }
    );
  }

  addEventPopup(eventData: any): void {
    if (eventData.event.uuid_event) {
      const uuid = eventData.event.uuid_event;
      const factory =
        this.resolver.resolveComponentFactory(EventPopupComponent);
      const componentRef = this.container.createComponent(factory);

      componentRef.instance.configuration = eventData;
      componentRef.instance.uuid = uuid;

      componentRef.instance.onDelete.subscribe((uuid: string) => {
        this.removePopup(uuid);
      });

      this.componentRefsMap[uuid] = componentRef;

      this.updateCarouselLayout();

      const timeoutId = setTimeout(() => {
        if (this.componentRefsMap[uuid]) {
          this.removePopup(uuid);
        }
      }, 120000); // 2 minutos

      componentRef.instance['_timeoutId'] = timeoutId;

      const originalDestroy = componentRef.destroy;
      componentRef.destroy = () => {
        clearTimeout(timeoutId);
        originalDestroy.apply(componentRef);
      };
      componentRef.changeDetectorRef.detectChanges();
      this.qtyItems++;

      // Asegurar que el carousel se muestre cuando se añade el primer item
      if (this.qtyItems === 1) {
        this.cdr.detectChanges();
      }
    }
  }

  removePopup(uuid: string): void {
    if (uuid) {
      const componentRef = this.componentRefsMap[uuid];
      if (componentRef.instance['_timeoutId']) {
        clearTimeout(componentRef.instance['_timeoutId']);
      }

      componentRef.destroy();
      delete this.componentRefsMap[uuid];

      const count = Object.keys(this.componentRefsMap).length;
      const newWidth = count * (240 + 8) - 8;

      this.carouselWrapper.nativeElement.style.width = `${newWidth}px`;

      setTimeout(() => {
        this.carouselWrapper.nativeElement.style.width = `${newWidth}px`;
      }, 0);
      this.qtyItems--;

      // Actualizar visibilidad del contenedor del carousel
      this.cdr.detectChanges();
    }
  }

  private updateCarouselLayout(): void {
    const itemWidthWithMargin = 240 + 8;

    const count = Object.keys(this.componentRefsMap).length;
    const totalWidth = count * itemWidthWithMargin - 8;

    this.carouselWrapper.nativeElement.style.width = `${totalWidth}px`;

    setTimeout(() => {
      this.carouselWrapper.nativeElement.style.width = `${totalWidth}px`;
    }, 0);
  }

  clearAllPopups(): void {
    for (const uuid in this.componentRefsMap) {
      const ref = this.componentRefsMap[uuid];
      ref.destroy();
      delete this.componentRefsMap[uuid];
    }

    this.carouselWrapper.nativeElement.style.width = '0px';

    setTimeout(() => {
      this.carouselWrapper.nativeElement.style.width = '0px';
    }, 0);

    // Establecer qtyItems a 0 para asegurar que el carousel se oculte
    this.qtyItems = 0;
    this.cdr.detectChanges();
  }

  private scrollToLatest(): void {
    setTimeout(() => {
      const count = Object.keys(this.componentRefsMap).length;
      if (count > 0) {
        const scrollPosition = (count - 1) * 248;
        this.carouselSection.nativeElement.scrollTo({
          left: scrollPosition,
          behavior: 'smooth',
        });
      }
    }, 100);
  }
  scrollCarousel(offset: number): void {
    this.carouselSection.nativeElement.scrollBy({
      left: offset,
      behavior: 'smooth',
    });
  }

  deleteMap(event: any) {
    if (document.getElementById('div-' + event)) {
      document.getElementById('div-' + event)?.remove();
      const currentWrapperWidth =
        parseFloat(this.carouselWrapper.nativeElement.style.width) || 0;
      const carouselSectionWidth =
        parseFloat(this.carouselSection.nativeElement.style.width) || 0;
      const extraWidth = 240 + 8;
      if (currentWrapperWidth != 0 && carouselSectionWidth != 0) {
        this.carouselWrapper.nativeElement.style.width = `${
          currentWrapperWidth - extraWidth
        }px`;
        this.carouselSection.nativeElement.style.width = `${
          carouselSectionWidth - extraWidth
        }px`;
      }
      this.qtyItems--;
      this.updateButtonVisibility();
    }
  }

  clearPopups() {
    const carouselWrapper = document.querySelector('.carousel-wrapper');
    if (carouselWrapper) {
      const popups = Array.from(carouselWrapper.children) as HTMLDivElement[];
      for (const popup of popups) {
        this.deleteMap(popup.id.slice(4));
      }
    }

    // Asegurar que qtyItems sea 0 cuando el carousel está vacío
    if (Object.keys(this.componentRefsMap).length === 0) {
      this.qtyItems = 0;
    }

    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  scrollCarouselx(amount: number) {
    var contenedor = document.getElementById('scroll-section')!;
    contenedor.scrollLeft += amount;
    this.cdr.detectChanges();
  }

  onScroll() {
    this.updateButtonVisibility();
    this.cdr.detectChanges();
  }

  updateButtonVisibility() {
    const container = this.carouselSection.nativeElement;
    const wrapper = this.carouselWrapper.nativeElement;
    const leftButton = document.getElementById('button-left');
    const rightButton = document.getElementById('button-right');

    if (container.scrollLeft === 0) {
      leftButton?.classList.add('invisible');
    } else {
      leftButton?.classList.remove('invisible');
    }
    //console.log(container.scrollLeft + container.clientWidth, wrapper.scrollWidth);

    if (container.scrollLeft + container.clientWidth === wrapper.scrollWidth) {
      rightButton?.classList.add('invisible');
    } else {
      rightButton?.classList.remove('invisible');
    }
  }
}
